import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '快递公司'
  }, {
    componentType: 'el-json',
    componentName: '输入框',
    fieldKey: 'key',
    fieldName: '快递公司关键字'
  }, {
    componentType: 'el-json',
    componentName: '输入框',
    fieldKey: 'automation',
    fieldName: 'API自动化开关'
  }
]
